import { Record } from 'immutable';

class Centre extends Record({
  id: undefined,
  timeZone: undefined,
  name: undefined,
  countryCode: undefined,
  businessLineCode: undefined
}) { }

export default Centre;



// WEBPACK FOOTER //
// ./data/Centre/model.js